var PO_AppBaseURL = '/apps/product-upsell-manager/';
var PO_AppScriptPath = PO_AppBaseURL + 'scripts/';
var PO_App_Front_Path = PO_AppBaseURL + 'app-front/';
var MSG_TYPE_ERROR = 'error';
var MSG_TYPE_NOTICE = 'notice';
var sc_po_jquery = null;
var variant_id = '';
var money_format = '';
var search_view_liquid = 'sc-pusm-products-27082016';
var upsell_offer = "";

function $_GET(q, s){
  s = ( s ) ? s : window.location.search;
  var re = new RegExp('&amp;' + q + '=([^&amp;]*)', 'i');
  return ( s = s.replace(/^\?/, '&amp;').match(re) ) ? s = s[1] : s = '';
}

function sc_pu_app_front_url(url){
  return PO_AppBaseURL + 'app-front' + ( /^\//.test(url) ? '' : '/' ) + url;
}

//$.ajax("/search?q=handle:mobile-back-cover&type=product&view=sc-pusm-01062016")

function sc_pu_init(){
  var script_hlpr = sc_po_script_helper();
  var other_scripts = [];
  var other_scripts = ["http://cdn.shopify.com/s/files/1/1477/2642/t/7/assets/sc-pusm-bs.js", PO_AppScriptPath + 'js/tmpl.js'];

  script_hlpr.check_jquery_version('1.9.1', function(){
    if(sc_po_jquery('#sc_pusm_container').length > 0){
      var sc_pusm_container = sc_po_jquery('#sc_pusm_container');
      var template = sc_pusm_container.data('template');
      var products = [];
      if(template == 'cart'){
        sc_po_jquery.ajax({
          type : 'GET',
          url : '/cart',
          dataType : 'json',
          async : false,
          success : function(data, textStatus, jqXHR){
            var cart = data;
            var cart_items = cart.items;
            sc_po_jquery(cart_items).each(function(index){
              products.push(this.product_id);
            });
            script_hlpr.load_scripts(other_scripts, function(){
              sc_po_jquery.ajax({
                type : 'POST',
                url : sc_pu_app_front_url('product_upsell/get_product_upsell'),
                data : {products : products},
                dataType : 'json',
                success : function(data, textStatus, jqXHR){
                  if(data.css){
                    sc_po_jquery('#sc_pusm_container').append(data.css);
                  }
                  if(data.custom_css){
                    sc_po_jquery('#sc_pusm_container').append("<style>"+data.custom_css+"</style>");
                  }
                  if(data.products){
                    var offer_html = '';
                    var odata = {};
                    odata.title = data.title;
                    upsell_offer = data.type;
                    if(upsell_offer == 'page'){
                      offer_html =	tmpl("sc_upsell_page", odata);
                    }
                    if(upsell_offer == 'popup'){
                      offer_html =	tmpl("sc_upsell_popup", odata);
                    }
                    sc_po_jquery('#sc_pusm_container').css('display', 'none').append(offer_html);
                    var offer_products = JSON.parse(data.products);
                    var offers_str = '';
                    var search_str = '/search?q=';
                    sc_po_jquery.each(offer_products, function(index, offer_product){
                      if(index > 0){
                        search_str += '+OR+'
                      }
                      search_str += 'handle:' + offer_product.handle;
                    });
                    search_str += '&type=product&view=' + search_view_liquid;
                    sc_po_jquery.ajax({
                      type : 'GET',
                      url : search_str,
                      dataType : 'json',
                      async : false,
                      success : function(data, textStatus, jqXHR){
                        sc_po_jquery.each(offer_products, function(index, offer_product){
                          var handle = offer_product.handle;
                          var product_index = null;
                          for(var i = 0; i < data.length; i++){
                            if(data[i].handle == handle){
                              product_index = i;
                              render_product(data[i]);
                              break;
                            }
                          }
                          data.splice(product_index, 1);
                        });
                        show_offers(offers_str);
                      }
                    });

                    function render_product(product){
                      var data = {};
                      data.variants = product.variants;
                      data.image = ( product.images.length > 0 ) ? product.images[0] : '';
                      data.handle = product.handle;
                      data.title = product.title;
																						data.id = product.id;
                      offers_str += tmpl("sc_upsell_"+upsell_offer+"_product", data);
                    }

                    function show_offers(offers_str){
                      sc_po_jquery('#sc-upsell-products').append(offers_str);
                      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
                        show_cart_icon();
                      }else{
                        sc_po_jquery('.sc-upsell-product').addClass('hover');
                      }
                      remove_product_link_for_touch();
                      sc_po_jquery('#sc_pusm_container').css('display', 'block');
                      if(typeof sc_po_jquery.fn.modal == 'function'){
                      	sc_po_jquery('#upsell_offer_modal').modal('show');  
                      }else{
                       	if(typeof jQuery.fn.modal == 'function'){
                      		jQuery('#upsell_offer_modal').modal('show');  
                      	}else{
                        	if(typeof $.fn.modal == 'function'){
                      			$('#upsell_offer_modal').modal('show');  
                      		}
                      	} 
                      }
                      
                    }
                    function remove_product_link_for_touch(){
                      sc_po_jquery('.sc-product-title').on('click', function(e){
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                      });
                    };
                    function show_cart_icon(){
                      sc_po_jquery('.cart-form-btn').bind('click',function(e){
                        e.preventDefault();
                        e.stopPropagation();
                        sc_po_jquery(this).parents('.sc-upsell-product').find('.sc-upsell-product-cart').toggle();
                      });
                      sc_po_jquery('.cart-form-btn').css('display','block');
                    }
                    function bind_upsell_product(){
                      sc_po_jquery('.sc-upsell-product-cart form').on('submit', function(e){
                        e.preventDefault();
                        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
                          if(!sc_po_jquery(this).hasClass('hover')){
                            sc_po_jquery(this).addClass('hover');
                            return false;
                          }
                        }
                        sc_po_jquery.ajax({
                          type : 'post',
                          url : '/cart/add.js',
                          data : {id : sc_po_jquery(this).find('#id').val(), quantity : 1},
                          dataType : 'json',
                          success : function(data, textStatus, jqXHR){
                            window.location = '/cart';
                          }
                        })
                      });
                    }
                    ;
                  }
                }
              });
              //		return false;
            });
          }
        })
      }
    }

  });
  function ShopifyAddToCart(custObj){
    properties = {};
    sc_po_jquery.each(custObj, function(key, value){
      if(key != "NewVarID"){
        properties[key] = value;
      }
    });
    //
    //        quantity = $("#txtQuantity").val();
    quantity = 1;
    param = "quantity=" + quantity + "&id=" + custObj.NewVarID;
    sc_po_jquery.each(properties, function(index, value){
      param = param + "&properties[" + encodeURIComponent(index) + "]=" + encodeURIComponent(value);
    });
    sc_po_jquery.ajax({
      type : "POST",
      url : '/cart/add.js',
      data : param,
      async : false,
    });
  }
}

( function(){
  sc_pu_init();
}() )

// *** [Helpers] *** //
function sc_po_script_helper(){
  return {
    /*
					* Checks if the provided jquery version(via 'check_version') is less than the currently loaded(or not loaded at all).
					* If true then loads the jQuery version(same as 'check_version') and callsback the provided callback method.              * P.S.- another callback is provided in the callee's callback to restore the previous jQuery version afterwards.
					*/
    check_jquery_version : function(check_version, callback){
      var self = this;
      if(check_version == '')
        check_version = '1.9.1';
      //			console.log('Scjq: ' + jQuery.fn.jquery);
      if(( typeof jQuery === 'undefined' ) || self.vn_hlpr.compare_versions(jQuery.fn.jquery, check_version, '<')){
        self.load_script('//ajax.googleapis.com/ajax/libs/jquery/' + check_version + '/jquery.min.js', function(){
          //sc_po_jquery = jQuery.noConflict(true);	//Alt: use noconflict only if jquery is loaded.
          sc_po_jquery = jQuery;
          callback(function(){
            //$ = jQuery.noConflict();	//Alt: NO NEED for this line , issue has been resolved by scJquery assignment.
            sc_po_jquery.noConflict(true);
          });
        });
      }else{
        sc_po_jquery = jQuery;
        callback(function(){});
      }
    },
    load_script : function(script_url, callback){
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src = script_url;
      document.getElementsByTagName("head")[0].appendChild(script);

      // If the browser is Internet Explorer.
      if(script.readyState){
        script.onreadystatechange = function(){
          if(script.readyState == "loaded" || script.readyState == "complete"){
            script.onreadystatechange = null;
            callback();
          }
        };
      }
      // For any other browser.
      else
        script.onload = function(){
          callback();
        };
    },
    load_scripts : function(script_urls_array, callback){
      var self = this;

      var scripts_loader = {
        scripts_arr : [],
        load_scripts_from_array : function(script_urls_arr, callback){
          var sl_self = this;
          sl_self.scripts_arr = [];
          for(var i = 0; i < script_urls_arr.length; i++){
            sl_self.scripts_arr.push([false, script_urls_arr[i]]);
            sl_self.load_single_script_by_index(i, callback);
          }
        },
        load_single_script_by_index : function(indx, callback){
          var sl_self = this;

          self.load_script(sl_self.scripts_arr[indx][1], function(){
            sl_self.scripts_arr[indx][0] = true;

            if(sl_self.is_all_script_loaded()){
              sl_self.scripts_arr = [];
              callback();
            }
          });
        },
        is_all_script_loaded : function(){
          var sl_self = this;
          var is_all_loaded = true;
          for(var i = 0; i < sl_self.scripts_arr.length; i++){
            var script = sl_self.scripts_arr[i];
            if(script[0] == false){
              is_all_loaded = false;
              break;
            }
          }
          return is_all_loaded;
        }
      }

      if(script_urls_array.length == 0)
        callback();
      else
        scripts_loader.load_scripts_from_array(script_urls_array, callback);
    },
    // Version Number Helper.
    vn_hlpr : {
      compare_versions : function(version1, version2, compare_option){
        var compared_versions = this.compare_version_result(version1, version2);

        if(compare_option){
          var option_matched = false;
          if(compared_versions == '='){
            if(( compare_option == '=' ) || ( compare_option == '<=' ) || ( compare_option == '>=' ))
              option_matched = true;
          }else if(compared_versions == '>'){
            if(( compare_option == '>' ) || ( compare_option == '>=' ))
              option_matched = true;
          }else if(compared_versions == '<'){
            if(( compare_option == '<' ) || ( compare_option == '<=' ))
              option_matched = true;
          }
          compared_versions = option_matched;
        }

        return compared_versions;
      },
      compare_version_result : function(v1, v2){
        var self = this;

        v1 = v1.toString();
        v2 = v2.toString();
        var v1_arr = v1.split('.');
        var v2_arr = v2.split('.');
        var v1_len = v1_arr.length;
        var v2_len = v2_arr.length;
        if(v1_len > v2_len)
          v2_arr = self.array_pad(v2_arr, v1_len, '0');
        else if(v1_len < v2_len)
          v1_arr = self.array_pad(v1_arr, v2_len, '0');

        var ret = '=';

        for(var i = 0; i < v1_arr.length; i++){
          var p1 = v1_arr[i];
          var p2 = v2_arr[i];

          var val1 = parseInt(p1);
          var val2 = parseInt(p2);
          if(val1 == val2){
            // Add checking so that *.1 is concidered greater than *.01 type numbers.
            var val1_len = p1.length;
            var val2_len = p2.length;

            if(val1_len != val2_len){
              if(val1_len > val2_len)
                p2 = self.string_pad(p2, val1_len, '0');
              else if(val1_len < val2_len)
                p1 = self.string_pad(p1, val2_len, '0');

              val1 = parseInt(p1);
              val2 = parseInt(p2);
            }
          }

          if(val1 == val2)
            continue;
          else{
            if(val1 > val2)
              ret = '>';
            else if(val1 < val2)
              ret = '<';
            break;
          }
        }
        return ret;
      },
      array_pad : function(arr, pad_size, pad_value){
        var arr_len = arr.length;
        for(var i = 0; i < ( pad_size - arr_len ); i++)
          arr.push(pad_value);
        return arr;
      },
      string_pad : function(str, pad_size, pad_value){
        var str_len = str.length;
        for(var i = 0; i < ( pad_size - str_len ); i++)
          str += pad_value;
        return str;
      }
    }
  }
}

function PU_Update_Data_URL(variant){
  if($('#sc-po-container').length > 0){
    if(variant != null){
      $('#sc-po-container').data('url', variant.id)
      variant_id = variant.id;
    }
  }
}